module.exports = __webpack_public_path__ + "img/thumb_24.73bf802a.jpg";